import * as userApi from '@/api/user'

const actions = {
  async fetchProfile() {
    const { data } = await userApi.getProfile()
    return data.data.user
  },

  async updateProfile({ commit }, payload) {
    const { data } = await userApi.updateProfile(payload)
    commit('auth/SET_USER', data.data.user, { root: true })
    return data
  },

  async resetApiKey() {
    const { data } = await userApi.resetApiKey()
    return data
  },
}

export default {
  namespaced: true,
  actions,
}
